export default {
  routerName: "management",
  routes: [
    {
      path: "/management/role-access",
      component: () => import("../management-role-access-view"),
    },
  ],
};
